export const selectGiftSearchFilters = ({ giftSearch: { filters } }) => filters
export const selectGiftSearchStats = ({ giftSearch: { stats } }) => stats
export const selectGiftSearchNameCache = ({ giftSearch: { nameCache } }) => nameCache
